import React, { useState, useEffect } from "react";

// Assets
import "~/assets/sass/pages/apply/applyEval.scss";
import { PaginationIcon } from "~/assets/svg/InterfaceIcon";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import lightProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import darkNewImg from "~/common/components/Images";

import { dateToString } from "~/utils/formatter";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useTranslation } from "react-i18next";
import { INVEST_LEVEL, TRANS_INDUSTRY_CATEGORY_LIST } from "~/constant/ApplyFormConstant";
import { COUNTRY_KOREAN } from "~/constant/ApplyManageConstant";

const ApplyEvalPopup = ({
	applyJudgeScore,
	applyResultModal,
	setApplyResultModal,
	info,
	company,
	applyJudgeDetail,
	applyDetail,
	userConfig,
	getListData,
}) => {

	const [itemScore, setItemScore] = useState({});
	const [finalData, setFinalData] = useState([]);
	const [calculatedScore, setCalculatedScore] = useState({});
	const [scoreSend, setScoreSend] = useState({});
	const [totalScore, setTotalScore] = useState(0);
	const [comment, setComment] = useState("");
	const { t } = useTranslation();

	const evalSubmitRequest = useRequest("post", `vc/apply/judge/score/${applyJudgeDetail?.idx}`);

	useEffect(() => {
		if (!applyResultModal) {
			setComment("")
			setTotalScore(0)
			setItemScore({})
			setCalculatedScore({})
			setFinalData([])
		}
	}, [applyResultModal])

	useEffect(() => {

		const score =
			Object.values(calculatedScore).length === 0 ? [0] : Object.values(calculatedScore);

		const total = score.filter(ele => !isNaN(ele)).reduce((acc, cur) => {
			acc = acc + (isNaN(cur) ? 0 : cur);
			// acc += cur;
			return acc;
		}, 0);


		setTotalScore(total);
	}, [calculatedScore]);

	useEffect(() => {
		let CalScore = [];
		let tmpScore = [];
		// if (!applyJudgeScore) {
		// 	setCalculatedScore({

		// 	});
		// 	setItemScore({

		// 	});
		// }
		// else {


		setComment(applyJudgeScore?.comment);
		applyJudgeScore?.details?.map((d) => {
			if (d.score) {
				const scoreKey = d.category.idx ? d.category.idx + "-" + d.item.idx.toString() : 0;
				const targetCate = applyJudgeDetail?.review?.categories?.find(
					(c) => c.idx === d.category.idx
				);

				const targetWeight = parseInt(targetCate?.weight);

				const itemNum = targetCate?.items.length;
				const calScore = (d.score / (10 * itemNum)) * targetWeight;

				CalScore = {
					...CalScore,
					[scoreKey]: calScore,
				};
				tmpScore = {
					...tmpScore,
					[scoreKey]: d.score,
				};
			}
		});

		setCalculatedScore({
			...CalScore,
		});
		setItemScore({
			...tmpScore,
		});
		// }
	}
		, [applyJudgeScore]);

	const answerMap = {
		SHORT(detailItem) {
			return detailItem.answer;
		},
		LONG(detailItem) {
			const brAnswer = detailItem.answer.replaceAll("\n", "<br />");
			return <div dangerouslySetInnerHTML={{ __html: brAnswer }} />;
		},
		CHOICE(detailItem) {
			return detailItem.answer;
		},
		SELECT(detailItem) {
			return detailItem.answer;
		},
		MULTISELECT(detailItem) {
			return detailItem.answer;
		},
		ALTERNATIVE(detailItem) {
			return detailItem.answer;
		},
		AGREE(detailItem) {
			return (
				<>
					<div>{detailItem.description}</div>
					<div>
						{detailItem.answer
							? t("pages.apply.ApplyEval.ApplyEvalPopup.agree")
							: t("pages.apply.ApplyEval.ApplyEvalPopup.disagree")}
					</div>
				</>
			);
		},
		TEXT(detailItem) { },
		FILE(detailItem) {
			return (
				<a href={detailItem.answer.path} target="_blank" rel="noreferrer">
					{detailItem.answer.name}
				</a>
			);
		},
		LINK(detailItem) {
			return (
				<a href={detailItem.answer} target="_blank" rel="noreferrer">
					{detailItem.answer}
				</a>
			);
		},
		ADDRESS(detailItem) {
			return detailItem.answer;
		},
		TAG(detailItem) {
			return detailItem.answer.map((tag, index) => (
				<div key={index}>
					{tag}
					{index !== detailItem.answer.length - 1 ? ", " : ""}
				</div>
			));
		},
		DATE(detailItem) {
			return dateToString(new Date(detailItem.answer), "yyyy-MM-dd");
		},
		CATEGORY(detailItem) {
			return detailItem.description;
		},
	};

	const handleScore = (e, catIdx, itemIdx, scoreIdx) => {
		const score = parseInt(e.target.value.replace(/\D/, ""));

		const scoreKey = catIdx.toString() + "-" + itemIdx.toString();
		const targetCate = applyJudgeDetail?.review?.categories?.find((d) => d.idx === catIdx);
		const targetWeight = parseInt(targetCate?.weight);

		//최종 데이터 갖고있기
		const changeScore = {
			idx: scoreIdx ? scoreIdx : null,
			categoryIdx: catIdx,
			itemIdx: itemIdx,
			score: isNaN(score) ? 0 : score,
		};

		//중복된 값 빼주기
		const tmpData = finalData.filter(
			(list) =>
				list.categoryIdx.toString() + "-" + list.itemIdx.toString() !==
				changeScore.categoryIdx.toString() + "-" + changeScore.itemIdx.toString()
		);
		const insertData = [...tmpData, changeScore];

		setFinalData(insertData);

		const itemNum = targetCate?.items.length;
		const calScore = (score / (10 * itemNum)) * targetWeight;

		if (score > 10 || isNaN(score) || score === "") {
			setItemScore({
				...itemScore,
				[scoreKey]: 0,
			});
			setCalculatedScore({
				...calculatedScore,
				[scoreKey]: 0,
			});
		} else {
			setItemScore({
				...itemScore,
				[scoreKey]: score,
			});
			setCalculatedScore({
				...calculatedScore,
				[scoreKey]: calScore,
			});
			setScoreSend({
				...scoreSend,
				[scoreKey]: { categoryIdx: catIdx, itemIdx: itemIdx },
			});
		}
	};

	const submitEvaluation = () => {
		const dataForm = {
			comment: comment,
			totalScore: totalScore,
			details: finalData,
		};
		evalSubmitRequest.call(dataForm, "body");
	};

	useEffect(() => {
		switch (evalSubmitRequest.state) {
			case API_STATE.done:
				// showConfirmAlert(true);
				setApplyResultModal(false);
				getListData();
				break;
			case API_STATE.error:
				console.log("irEvaluateForm Error");
				break;
			default:
				break;
		}
	}, [evalSubmitRequest.state, evalSubmitRequest.response, evalSubmitRequest.error]);

	const translateIndustryField = () => {
		let fieldList = [];
		applyDetail?.startup?.industryField
			?.split(",")
			.map((field) => fieldList.push(TRANS_INDUSTRY_CATEGORY_LIST[field] || field));
		return fieldList.join();
	};

	const flattendContents =
		applyDetail?.content
			?.reduce((acc, curr) => {
				if (curr.contents && curr.contents.length > 0) {
					acc.push(...curr.contents);
				}
				return acc;
			}, [])
			.sort(function (a, b) {
				return a.order - b.order;
			}).splice(7) ?? [];


	const basicInfo = (item) => {
		if (item.title === "기업명") return applyDetail?.startup?.name;
		if (item.title === "대표자 이름") return applyDetail?.startup?.ceo;
		if (item.title === "대표자 이메일") return applyDetail?.startup?.email;
		if (item.title === "설립연월")
			return dateToString(new Date(applyDetail?.startup?.establishedAt), "yyyy-MM-dd");
		if (item.title === "국가")
			return COUNTRY_KOREAN[applyDetail?.startup?.country] || applyDetail?.startup?.country;
		// return applyDetail?.startup?.country === "korea"
		// 	? t("pages.apply.ApplyList.ApplyListTable.republicOfKorea")
		// 	: t("pages.apply.ApplyList.ApplyListTable.foreign");
		if (item.title === "산업분야") return applyDetail?.startup?.industryField;
		if (item.title === "투자단계")
			return (
				INVEST_LEVEL.find((value) => value.value === applyDetail?.startup?.investLevel)
					?.label ?? "-"
			);
		else return item.answer ? answerMap[item.type](item) : "-";
	};

	return (
		<ModalTemplate
			modalState={applyResultModal}
			setModalToggle={setApplyResultModal}
			title={
				<div className="applicant-detail-header">
					{t("pages.apply.ApplyEval.ApplyEvalPopup.evaluateApply")}
				</div>
			}
			width={1470}
			height={930}
			className="apply-result-modal evaluate-result-wrap"
		>
			<div className="arrow-btn prev-btn">
				<PaginationIcon />
			</div>
			<div className="modal-content">
				<div className="applicant-detail-body form-wrap">
					<div className="applicant-info">
						<div className="company-info-wrap">
							<div className="company-info">
								<h4 className="company-name">{applyDetail?.startup?.name}</h4>
								<span className="company-abst">
									{COUNTRY_KOREAN[applyDetail?.startup?.country] ||
										applyDetail?.startup?.country}
									/{" "}
									{applyDetail?.startup?.establishedAt && (
										<span>
											{new Date().getFullYear() -
												parseInt(
													applyDetail.startup.establishedAt.substring(
														0,
														4
													)
												) +
												1}
											{t("pages.apply.ApplyEval.ApplyEvalPopup.yearStandard")}
										</span>
									)}{" "}
									/ {translateIndustryField()}
								</span>
							</div>
						</div>
						<div className="evaluate-info">
							<span className="evaluate-state">
								{applyJudgeDetail?.investStatus === "심사중"
									? t("pages.apply.ApplyEval.ApplyEvalPopup.underEvaluate")
									: applyJudgeDetail?.investStatus === "심사완료"
										? t("pages.apply.ApplyEval.ApplyEvalPopup.doneEvaluate")
										: t("pages.apply.ApplyEval.ApplyEvalPopup.waitingEvaluate")}
							</span>
							{/*<span className="evaluate-state">심사완료</span>*/}
							{/*<span className="evaluate-state">심사대기</span>*/}
							<span className="evaluate-date">
								{dateToString(applyDetail?.createdAt, "yyyy-MM-dd")}{" "}
								{t("pages.apply.ApplyEval.ApplyEvalPopup.apply")}
							</span>
						</div>
					</div>
					<section>
						<h3 className="section-title">
							{t("pages.apply.ApplyEval.ApplyEvalPopup.basicInfo")}
						</h3>
						<div className="c__form basic-info">
							<div className="f__group">
								<div className="f__label">
									{t("pages.apply.ApplyEval.ApplyEvalPopup.companyName")}
								</div>
								<div className="f__control">{applyDetail?.startup?.name}</div>
							</div>
							<div className="f__group">
								<div className="f__label">
									{t("pages.apply.ApplyEval.ApplyEvalPopup.ceoName")}
								</div>
								<div className="f__control">{applyDetail?.startup?.ceo}</div>
							</div>
							{/*<div className="f__group">*/}
							{/*	<div className="f__label">*/}
							{/*		{t("pages.apply.ApplyEval.ApplyEvalPopup.ceoPhone")}*/}
							{/*	</div>*/}
							{/*	<div className="f__control">*/}
							{/*		{applyDetail?.startup?.ceoContact ?? "-"}*/}
							{/*	</div>*/}
							{/*</div>*/}
							<div className="f__group">
								<div className="f__label">
									{t("pages.apply.ApplyEval.ApplyEvalPopup.ceoEmail")}
								</div>
								<div className="f__control">{applyDetail?.startup?.email}</div>
							</div>
							{/*<div className="f__group">*/}
							{/*	<div className="f__label">*/}
							{/*		{t("pages.apply.ApplyEval.ApplyEvalPopup.employeeNum")}*/}
							{/*	</div>*/}
							{/*	<div className="f__control">*/}
							{/*		{applyDetail?.startup?.employeeNum ?? "-"}*/}
							{/*		{t("pages.apply.ApplyEval.ApplyEvalPopup.employeeNumStandard")}*/}
							{/*	</div>*/}
							{/*</div>*/}
							<div className="f__group">
								<div className="f__label">
									{t("pages.apply.ApplyEval.ApplyEvalPopup.establishedAt")}
								</div>
								<div className="f__control">
									{dateToString(
										applyDetail?.startup?.establishedAt,
										"yyyy-MM-dd"
									)}
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">
									{t("pages.apply.ApplyEval.ApplyEvalPopup.country")}
								</div>
								<div className="f__control">
									{COUNTRY_KOREAN[applyDetail?.startup?.country] ||
										applyDetail?.startup?.country}
								</div>
							</div>
							<div className="f__group">
								<div className="f__label">
									{t("pages.apply.ApplyEval.ApplyEvalPopup.industryField")}
								</div>
								<div className="f__control">{translateIndustryField()}</div>
							</div>
						</div>
					</section>


					{/* <section>
						<h3 className="section-title">
							{t("pages.apply.ApplyEval.ApplyEvalPopup.investInfo")}
						</h3>
						<div className="c__form">
							<div className="f__group">
								<div className="f__label">
									{t("pages.apply.ApplyEval.ApplyEvalPopup.investLevel")}
								</div>
								<div className="f__control">
									{applyDetail?.startup?.investLevel &&
										(INVEST_LEVEL.find(
											(value) =>
												value.value === applyDetail?.startup?.investLevel
										)?.label ??
											"-")}
									 {applyDetail?.startup?.investLevel}
								</div>
							</div>
						</div>
					</section> */}


					{flattendContents.length > 0 &&
						flattendContents.map((item, idx) => (
							<section>
								{item.type === "CATEGORY" && (
									<h3 className="section-title">{item.category}</h3>
								)}
								<div className="c__form">
									{item?.type !== "TEXT" && item?.type !== "CATEGORY" && (
										<div className="f__group">
											<div className="f__label">{item.title}</div>
											<div className="f__control">
												{item.answer ? answerMap[item.type](item) : basicInfo(item)}
											</div>
										</div>
									)}
								</div>
							</section>
						))}
				</div>
				<div className="applicant-evaluate-body">
					<div className="scroll-wrap">

						{applyDetail?.status === '심사완료' ?
							applyJudgeDetail?.judges.map(ele =>
								<div>
									<div className="judge-form-top">
										<div className="judging-vc-wrap">

											<div className="img-wrap">
												{/* investStatus */}

												<img
													src={
														ele.user.img
															? ele.user.img
															: userConfig == "dark"
																? darkNewImg
																: lightProfileImg
													}
													alt={t("pages.apply.ApplyEval.ApplyEvalPopup.judgeImg")}
												/>
											</div>
											<dl className="judging-vc">
												<dt>{ele.user.name}</dt>
												<dd>{company.name}</dd>
											</dl>
											{/* investStatus */}
										</div>
										<div className="judging-vc-score">
											{isNaN(ele.score.totalScore) ? (
												<b>-</b>
											) : (
												<>
													<b>{ele.score.totalScore?.toFixed(2)}</b>
													{t("pages.apply.ApplyEval.ApplyEvalPopup.scoreStandard")}
												</>
											)}
										</div>
									</div>

									{ele?.review?.categories?.map((category) => (
										<div className="judge-detail-item">
											<div className="category-title">
												{category.title}
												<span>
													{t("pages.apply.ApplyEval.ApplyEvalPopup.scoreWeight")} :{" "}
													{category?.weight}%
												</span>
											</div>
											<form className="c__form">
												{category?.items?.map((item, itemIdx) => {
													return (
														<div className="f__group" key={item.idx}>
															<div className="f__label">
																{itemIdx + 1}. {item.content}
															</div>
															<div className="f__control">
																<input
																	className="c__input"
																	onChange={(e) =>
																		handleScore(
																			e,
																			category.idx,
																			item.idx,
																			item.score ? item.score.idx : null
																		)
																	}
																	value={
																		item?.score
																	}
																	disabled={
																		applyDetail?.status === "심사완료"
																	}
																/>
															</div>
														</div>
													);
												})}
											</form>
										</div>
									))}
									<div className="judge-commentary">
										<div className="category-title">
											{t("pages.apply.ApplyEval.ApplyEvalPopup.totalEvaluation")}
										</div>
										<div className="f__group">
											<div className="f__control">
												{/*	심사하기 모달일 때*/}
												<textarea
													value={ele.score.comment}
													className="c__textarea"
													onChange={(e) => {
														setComment(e.target.value);
													}}
													readOnly={applyDetail?.status === "심사완료"}
												/>

												{/*	결과보기 모달일 때 readonly*/}
												{/*<textarea className="c__textarea" readOnly/>*/}
											</div>
										</div>
									</div>
								</div>

							)
							:
							<div>
								<div className="judge-form-top">
									<div className="judging-vc-wrap">

										<div className="img-wrap">
											{/* investStatus */}

											<img
												src={
													info.img
														? info.img
														: userConfig == "dark"
															? darkNewImg
															: lightProfileImg
												}
												alt={t("pages.apply.ApplyEval.ApplyEvalPopup.judgeImg")}
											/>
										</div>
										<dl className="judging-vc">
											<dt>{info.name}</dt>
											<dd>{company.name}</dd>
										</dl>
										{/* investStatus */}
									</div>
									<div className="judging-vc-score">
										{isNaN(totalScore) ? (
											<b>-</b>
										) : (
											<>
												<b>{totalScore?.toFixed(2)}</b>
												{t("pages.apply.ApplyEval.ApplyEvalPopup.scoreStandard")}
											</>
										)}
									</div>
								</div>

								{applyJudgeDetail?.review?.categories?.map((category) => (
									<div className="judge-detail-item">
										<div className="category-title">
											{category.title}
											<span>
												{t("pages.apply.ApplyEval.ApplyEvalPopup.scoreWeight")} :{" "}
												{category?.weight}%
											</span>
										</div>
										<form className="c__form">
											{category?.items?.map((item, itemIdx) => {
												return (
													<div className="f__group" key={item.idx}>
														<div className="f__label">
															{itemIdx + 1}. {item.content}
														</div>
														<div className="f__control">
															<input
																className="c__input"
																onChange={(e) =>
																	handleScore(
																		e,
																		category.idx,
																		item.idx,
																		item.score ? item.score.idx : null
																	)
																}
																value={
																	itemScore[
																	category.idx.toString() +
																	"-" +
																	item.idx.toString()
																	] || 0
																}
																disabled={
																	applyDetail?.status === "심사완료"
																}
															/>
														</div>
													</div>
												);
											})}
										</form>
									</div>
								))}
								<div className="judge-commentary">
									<div className="category-title">
										{t("pages.apply.ApplyEval.ApplyEvalPopup.totalEvaluation")}
									</div>
									<div className="f__group">
										<div className="f__control">
											{/*	심사하기 모달일 때*/}
											<textarea
												value={comment}
												className="c__textarea"
												onChange={(e) => {
													setComment(e.target.value);
												}}
												readOnly={applyDetail?.status === "심사완료"}
											/>

											{/*	결과보기 모달일 때 readonly*/}
											{/*<textarea className="c__textarea" readOnly/>*/}
										</div>
									</div>
								</div>
							</div>
						}


					</div>
					<div className="modal-footer">
						{/*	심사하기 모달일 때 버튼*/}
						{applyDetail?.status === "심사완료" ? (
							<button
								type="button"
								className="btn__solid"
								color="gray"
								onClick={() => {
									setApplyResultModal(false);
								}}
							>
								{t("pages.apply.ApplyEval.ApplyEvalPopup.confirm")}
							</button>
						) : (
							<button
								type="button"
								className="btn__solid"
								color="primary"
								onClick={() => submitEvaluation()}
							>
								{t("pages.apply.ApplyEval.ApplyEvalPopup.save")}
							</button>
						)}

						{/*	결과보기 모달일 때 버튼*/}
						{/*<button type="button" className="btn__solid" color="gray">*/}
						{/*	심사취소*/}
						{/*</button>*/}
						{/*<button type="button" className="btn__solid" color="primary">*/}
						{/*	저장하기*/}
						{/*</button>*/}
					</div>
				</div>
			</div>
			<div className="arrow-btn next-btn">
				<PaginationIcon />
			</div>
		</ModalTemplate>
	);
};

export default ApplyEvalPopup;
